import { createContext, useContext, useRef, type RefObject } from "react";

type ScrollContainerRef = RefObject<HTMLDivElement | null>;

const ScrollContainerContext = createContext<ScrollContainerRef | null>(null);

/**
 * Provider that holds a stable ref to the app's main scroll container.
 * Wrap your layout with this and attach scrollRef to the scrollable div.
 */
export function ScrollContainerProvider({ children }: { children: React.ReactNode }) {
  const scrollRef = useRef<HTMLDivElement | null>(null);
  return (
    <ScrollContainerContext.Provider value={scrollRef}>
      {children}
    </ScrollContainerContext.Provider>
  );
}

/**
 * Returns the stable ref to the main scroll container element.
 * The ref is created once and never changes — only .current updates.
 */
export function useScrollContainer(): ScrollContainerRef {
  const ctx = useContext(ScrollContainerContext);
  if (!ctx) throw new Error("useScrollContainer must be used within ScrollContainerProvider");
  return ctx;
}
